import React, {useCallback} from 'react';
import {Button, Highlight, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useToast} from "@chakra-ui/react";
import useRequest from "../../../hooks/RequestHook";
import ServerService from "../../../services/ServerService";

export default function DeleteFKSGroupModal({fksGroup, controller, onDelete = (fksGroup) => undefined, ...props}) {
    //initial components
    const toast = useToast()

    //initial requests
    const deleteFKSGroupRequest = useRequest(ServerService.deleteFKSGroup, {
        defaultConfig: {
            id: fksGroup['_id']
        }
    })

    //initial actions
    const onDeleteFKSGroup = useCallback(() => {
        deleteFKSGroupRequest.start(undefined, {
            onSuccessCallBack: (response, data) => {
                controller.onClose()
                onDelete(fksGroup)
                toast({
                    title: fksGroup['number'],
                    description: `ФКС группа ${fksGroup['number']} удалена`,
                    position: 'top-right',
                    status: 'success',
                    isClosable: true,
                })
            },
            onErrorCallBack: () => (
                toast({
                    title: fksGroup['number'],
                    description: `Ошибка удаления ФКС группы ${fksGroup['number']}`,
                    position: 'top-right',
                    status: 'error',
                    isClosable: true,
                })
            )
        })
    }, [])

    //build view
    return (
        <Modal
            closeOnOverlayClick={false}
            returnFocusOnClose={false}
            isOpen={controller.isOpen}
            onClose={controller.onClose}
            {...props}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader userSelect={'none'}>Удаление ФКС группы</ModalHeader>
                <ModalBody pb={6} userSelect={'none'}>
                    <Highlight
                        query={fksGroup['number']}
                        styles={{
                            px: '1',
                            color: 'white',
                            fontWeight: 'medium',
                            bg: 'red.500',
                            rounded: '5',
                        }}>
                        {`Вы действительно хотите удалить группу ФКС ${fksGroup['number']} ?`}
                    </Highlight>
                </ModalBody>
                <ModalFooter>
                    <Button
                        colorScheme='red'
                        width={'100%'}
                        mr={3}
                        onClick={onDeleteFKSGroup}
                        isLoading={deleteFKSGroupRequest.isLoading}>Удалить</Button>
                    <Button
                        width={'100%'}
                        onClick={() => controller.onClose()}
                        isDisabled={deleteFKSGroupRequest.isLoading}>Отмена</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}